var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.eventAttendances,"loading":_vm.isLoading},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"success","data-cy":"EventAttendance-button-new","to":{
          name: 'membership-EditEventAttendance',
          query: {
            eventId: _vm.eventId,
          },
        }}},[_vm._v(" "+_vm._s(_vm.$$t('new'))+" ")]),_c('v-btn',{staticClass:"ml-3",attrs:{"color":"primary","data-cy":"EventAttendance-button-all","to":{
          name: 'membership-ListEvent',
          query: {
            eventId: _vm.eventId,
          },
        }}},[_vm._v(" "+_vm._s(_vm.$$t('all'))+" ")])],1)]},proxy:true},{key:"item.actions",fn:function({ item }){return [_c('v-btn',{attrs:{"color":"error","small":""},on:{"click":function($event){return _vm.remove(item)}}},[_vm._v(" "+_vm._s(_vm.$t('common.buttons.delete'))+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }